var map = {
	"./CategorizingEssaysAI.webp": 266,
	"./NeuroNote.webp": 493,
	"./NeuroNote/ProductMarketingPage.webp": 920,
	"./NeuroNote/README.md": 813,
	"./WordConnect.webp": 152,
	"./WordConnect/README.md": 490,
	"./WordConnect/wordConnectDemo.gif": 245,
	"./WordConnect/wordConnectSessionEnd.png": 640,
	"./logo.png": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;